import { request } from "../../utils/config"

export const GET_COUNTERPARTIES = async (params) => {
  const response = await request({
    url: `Counterparties`,
    params: params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const GET_ALL_COUNTERPARTIES = async (params) => {
  const response = await request({
    url: `Counterparties`,
    params: { ...params, PageSize: 10000000 },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const GET_COUNTERPARTY = async (id: number) => {
  const response = await request({
    url: `Counterparties/${id}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const GET_COUNTERPARTY_DEBTS = async (params) => {
  const response = await request({
    url: `Reports/reportCounterpartyHistories`,
    params: params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const GET_ALL_COUNTERPARTY_DEBTS = async (params) => {
  const response = await request({
    url: `Reports/reportCounterpartyHistories`,
    params: { ...params, pageSize: 10000000 },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}
